import type { ReactNode } from "react";
import { injectCss } from "../core/injectCss";

const CSS = `
.js-dialog__scrim{
  position:fixed;inset:0;background:rgba(33,30,19,.42);
  backdrop-filter:blur(2px);display:flex;align-items:center;justify-content:center;
  padding:24px;z-index:1000;animation:js-scrim-in var(--dur-base) var(--ease-out);
}
@keyframes js-scrim-in{from{opacity:0}to{opacity:1}}
.js-dialog{
  background:var(--surface-card);border-radius:var(--radius-xl);box-shadow:var(--shadow-xl);
  width:100%;max-width:440px;overflow:hidden;font-family:var(--font-sans);
  animation:js-dialog-in var(--dur-slow) var(--ease-spring);
}
@keyframes js-dialog-in{from{opacity:0;transform:translateY(12px) scale(.97)}to{opacity:1;transform:none}}
.js-dialog__head{padding:20px 24px 0;display:flex;gap:10px;align-items:center}
.js-dialog__icon{width:36px;height:36px;border-radius:var(--radius-md);display:flex;align-items:center;justify-content:center;flex:none;background:var(--brand-subtle);color:var(--brand)}
.js-dialog--danger .js-dialog__icon{background:var(--danger-bg);color:var(--danger-fg)}
.js-dialog__title{font-size:var(--text-h3);font-weight:var(--weight-bold);color:var(--text-strong);line-height:1.2}
.js-dialog__body{padding:8px 24px 0 24px;font-size:var(--text-body);color:var(--text-body);line-height:var(--leading-normal)}
.js-dialog__foot{display:flex;justify-content:flex-end;gap:10px;padding:20px 24px}
@media(max-width:767px){
  .js-dialog__scrim{padding:0;align-items:flex-end}
  .js-dialog{max-width:100%;border-radius:var(--radius-xl) var(--radius-xl) 0 0;max-height:92dvh;overflow-y:auto;padding-bottom:env(safe-area-inset-bottom,0px)}
  @keyframes js-dialog-in{from{opacity:0;transform:translateY(100%)}to{opacity:1;transform:none}}
}
`;

export interface DialogProps {
  open?: boolean;
  tone?: "brand" | "danger";
  icon?: ReactNode;
  title?: ReactNode;
  footer?: ReactNode;
  onClose?: () => void;
  closeOnBackdrop?: boolean;
  className?: string;
  children?: ReactNode;
}

export function Dialog({
  open = true,
  tone = "brand",
  icon,
  title,
  footer,
  onClose,
  closeOnBackdrop = true,
  className = "",
  children,
}: DialogProps) {
  injectCss("js-dialog-css", CSS);
  if (!open) return null;
  return (
    <div className="js-dialog__scrim" onClick={closeOnBackdrop ? onClose : undefined}>
      <div
        className={[
          "js-dialog",
          tone === "danger" ? "js-dialog--danger" : "",
          icon ? "js-dialog--has-icon" : "",
          className,
        ]
          .filter(Boolean)
          .join(" ")}
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        {(title || icon) && (
          <div className="js-dialog__head">
            {icon && <span className="js-dialog__icon">{icon}</span>}
            {title && <h3 className="js-dialog__title">{title}</h3>}
          </div>
        )}
        {children && <div className="js-dialog__body">{children}</div>}
        {footer && <div className="js-dialog__foot">{footer}</div>}
      </div>
    </div>
  );
}
